module.exports = __webpack_public_path__ + "prod/20260124143402/img/smallProgram.e5352668.jpg";